export const individualLegalForm = [
  { id: 1, label: "Individual enterprise", hardvalue: null },
  { id: 4, label: "Solo Trader", hardvalue: "solo_trader" },
];

export const legalForm = [
  ...individualLegalForm,
  {
    id: 2,
    label: "Private limited liability company",
    hardvalue: null,
  },
  { id: 3, label: "Small partnership", hardvalue: null },
];

export const isIndividualLegalForm = (id: number) => {
  if (!id) return false;
  const isIndividual = individualLegalForm?.find((l) => l.id == id);
  return !!isIndividual;
};

export const fetchLegalFormLabel = (id: number) => {
  if (!id) return "";
  const legalForm = individualLegalForm?.find((l) => l.id == id);
  return legalForm?.label || "";
};
